module.exports = require('./helpers/bundle-url').getBundleURL('jn75v') + "logo-dark.eefe0b7f.svg";